var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 71,
    viewBox: "0 0 182 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_154)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 182,
    height: 71
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.517 0.5H0.482758V70.5H181.517V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.511 22.0986C30.7186 11.8193 24.8979 2.86202 21.8661 0.709259C21.8523 0.695397 21.5823 0.550052 21.603 0.951536C21.603 0.958432 21.5961 0.958432 21.5961 0.965363C21.2848 20.382 11.3041 25.6151 5.88476 32.731C-6.15834 48.5548 3.89133 66.6079 16.9103 70.0272C17.132 70.0827 17.7341 70.2627 18.8761 70.4979C19.4713 70.6227 19.6444 70.1172 19.2082 69.3627C17.651 66.6562 14.8823 62.0875 14.3358 56.2175C13.0899 42.5879 30.2686 34.06 30.511 22.0986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0724 28.6817C36.9686 28.6055 36.8234 28.6124 36.8097 28.7437C36.5328 31.2151 33.9786 36.3375 30.6148 41.1275C19.2914 57.2768 24.9948 64.6003 29.4245 69.6813C30.241 70.6227 30.6493 70.4151 31.0786 69.7437C31.48 69.1068 32.089 68.2968 34.7055 67.0579C35.1138 66.8641 44.9976 61.6172 46.0703 49.6696C47.1017 38.1096 39.6886 30.7996 37.0724 28.6817Z",
    fill: "#008CD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8697 25.7396V68.2344H86.7541V51.0679H69.2362V68.2344H59.8924V25.7396H69.2362V42.9065H86.7541V25.7396H95.8697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.014 25.7396V34.1431H133.674H124.926V68.2276H115.547V34.1431H107.034H102.694V25.7396H138.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.209 68.2762L160.494 53.4903L149.863 68.2138L139.467 68.2276L155.227 46.5338L140.353 25.7396H150.742L181.556 68.2762H171.209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.408 35.2506L168.551 42.3944L180.732 25.7327H170.399L163.408 35.2506Z",
    fill: "#008CD6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181.034,
    height: 70,
    fill: "white",
    transform: "translate(0.482758 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtx);
export default __webpack_public_path__ + "static/media/htx.b9c15d291dee2d50fabf291f4df253f4.svg";
export { ForwardRef as ReactComponent };